import type { ConfigRequest } from '@pba/react-utils';
import { type ApiClientResponse, type CursorPaginationRailsParams, apiClient, routes } from 'common/services';
import type { ContentObjectListDataObject } from 'models/service';

type ContentObjectsRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  community_id?: string;
  group_id?: string;
  pinned?: boolean;
  program_id?: string;
  program_topic_id?: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
} & CursorPaginationRailsParams;

export const getContentObjects = async ({ config }: ConfigRequest<ContentObjectsRequest>) =>
  apiClient.get<ContentObjectListDataObject[], ApiClientResponse<ContentObjectListDataObject[]>>(
    routes.contentObjects.index,
    config,
  );
